const state = {
    accessToken: localStorage.getItem('token') ? localStorage.getItem('token') : '',
    userID: localStorage.getItem('acc_user_id') ? localStorage.getItem('acc_user_id') : '',
    version:'1.0.1',
}

const mutations = {
    SET_TOKEN: (state, token) => {
        localStorage.setItem('token', 'Bearer ' + token)
        state.accessToken = 'Bearer ' + token
    },
    SET_UserID: (state, userID) => {
        localStorage.setItem('acc_user_id', userID)
        state.userID = userID
    },
    REMOVE_TOKEN: (state) => {
        localStorage.removeItem('token')
        state.accessToken = ''
    },
    REMOVE_USERID: (state) => {
        localStorage.removeItem('acc_user_id')
        state.userID = ''
    }
}
const actions = {
    setToken({ commit }, token) {
        return new Promise(resolve => {
            commit('SET_TOKEN', token)
            console.log('token',token,resolve())
            resolve()
        })
    },
    setUserID({ commit }, userID) {
        return new Promise(resolve => {
            commit('SET_UserID', userID)
            console.log('userID',userID,resolve)
            resolve()
        })
    },
    removeToken({ commit }) {
        return new Promise(resolve => {
            commit('REMOVE_TOKEN')
            resolve()
        })
    },
    removeUserID({ commit }) {
        return new Promise(resolve => {
            commit('REMOVE_USERID')
            resolve()
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}